import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import CardClickArea from './components/CardClickArea';
import CardHover from './components/CardHover';
import Menu from './components/Menu';
import SliderCollection from './components/SliderCollection';
import SliderFeaturedItems from './components/SliderFeaturedItems';
import Accordion from './components/Accordion';
import Media from './components/Media';
import CardFadeIn from './components/CardFadeIn';


export class App {
	constructor() {
		Promise.all([App.domReady()]).then(() => this.init());
	}

	init() {
		document.dispatchEvent(new Event('bless'));

		new Menu();
		new Accordion();

		document.querySelectorAll('[data-card-link]').forEach((el) => {
			new CardClickArea(el);
		});


		document.querySelectorAll('[data-hero]').forEach((el) => {
			new Media(el);
		});

		document.querySelectorAll('[data-card-fadein]').forEach((el) => {
			new CardFadeIn(el);
		});

		document.querySelectorAll('[data-card]').forEach((el) => {
			new CardHover(el);
		});


		document.querySelectorAll('[data-slider]').forEach((elm) => {
			new SliderCollection(elm);
		});

		document.querySelectorAll('[data-slider-items]').forEach((elm) => {
			new SliderFeaturedItems(elm);
		});

	}

	static domReady() {
		return new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve));
	}
}

new App();
